import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

interface ModalPortalProps {
  children: React.ReactNode;
  modalRootId: string; 
  onClose: () => void;
  contentClassName?: string;
}

const ModalPortal: React.FC<ModalPortalProps> = ({
  children,
  modalRootId,
  onClose,
  contentClassName,
}) => {
  const mousedownStartedInModal = useRef(false);

  useEffect(() => {
    // Prevent scrolling when modal is open
    document.body.style.overflow = 'hidden';
    
    return () => {
      // Restore scrolling when modal closes
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && !mousedownStartedInModal.current) {
      onClose();
    }
    mousedownStartedInModal.current = false;
  };

  const handleModalContentMouseDown = () => {
    mousedownStartedInModal.current = true;
  };

  // Use a fixed modal root element that should exist in the DOM
  const modalRoot = document.getElementById(modalRootId) || document.body;

  return ReactDOM.createPortal(
    <div className={modalRootId} onClick={handleBackdropClick}>
      <div className={contentClassName} onMouseDown={handleModalContentMouseDown}>
        {children}
      </div>
    </div>,
    modalRoot
  );
};

export default ModalPortal;
